/** @format */
import { stringify } from 'qs';

import { toSnakeCase } from '@toucan/common/helpers/change-case';
import { SearchFacet } from '@toucan/common/services/search/constants';
import { getSearchParamKey } from '@toucan/common/services/search/helpers';
import { ModelSearchResultsSearchParams } from '@toucan/common/services/search/types';

export function getQueryStringFromSearchParams(
    searchParams: ModelSearchResultsSearchParams
) {
    const { selectedFilters, variants } = searchParams;

    return stringify(
        {
            [getSearchParamKey(SearchFacet.productPrice)]:
                selectedFilters?.productPrice,
            [getSearchParamKey(SearchFacet.productConditionStarRating)]:
                selectedFilters?.productConditionStarRating,
            [`variant_${toSnakeCase(SearchFacet.productPrice)}`]:
                variants?.productPrice,
        },
        {
            addQueryPrefix: true,
            arrayFormat: 'repeat',
        }
    );
}
